


























import Vue from 'vue';

export default Vue.extend({
  name: "Dropdown",
  props: [
    'name',
    'id',
    'description'
  ],
  data() {
    return {
      file: false,
      error: false,
      message: false
    }
  },
  methods: {
    upload(){
      if(this.file){
        this.$store.dispatch('upload', { id: this.id, name: this.name, file: this.file})
        .then(function(result: any) {
          if(result.data.message.sucess){
            this.$store.dispatch('addMessage', { message: "Erfolgreich hochgeladen!", type: "success"});
          } else {
            this.$store.dispatch('addMessage', { message: result.data.message.message, type: "error"});

          }
          this.$emit('upload',{ sucess: result.data.message.sucess, file: result.data.message.message });
        }.bind(this));
      }
    },
    onFileChange(e: any){
      const files = e.target.files || e.dataTransfer.files;
      if (files.length != 0){
        this.file = files[0];
      }
    }
  },
  computed: {
  }
});
